import React from "react";

import { DocumentDuplicateIcon } from "@heroicons/react/20/solid";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";

import Button from "../../../shared/components/FormElements/Button";

const CopyButton = (props) => {
	return (
		<Button
			onClick={() => {
				let contentToCopy =
					document.getElementById("documentContent").innerText;
				navigator.clipboard.writeText(contentToCopy);
				toast.success("Gekopieerd naar je klembord", {
					position: "bottom-center",
					theme: "light",
					icon: (
						<CheckCircleIcon
							className=" text-green-500"
							aria-hidden="true"
						/>
					),
				});
			}}
			classNames="w-full center"
		>
			<div className="flex">
				<DocumentDuplicateIcon className="w-5 mr-2" />
				Kopieer document
			</div>
		</Button>
	);
};

export default CopyButton;
